import { AUTH_PRIVILEGES } from "../api";
import { DASHBOARD, FETCH_AUTH_PRIVILEGE, FETCH_CURRENT_USER} from "../Dispatchers";

const initialState = {
    currentUser: {},
    dashboardData: {},
    privileges:[]
}
export function UserReducer(state = initialState, action) {
    switch (action.type) {
        case DASHBOARD:
            return {
                ...state, dashboardData: action.payload
            }
        case FETCH_CURRENT_USER:
            return {
                ...state, currentUser: action.payload
            }
        case FETCH_AUTH_PRIVILEGE:
            return {
                ...state, privileges: action.payload
            }

        default:
            break;
    }
    return state;
}